export type SlotDTO = {
    slot_id?: number;
    start_time: string;
    end_time: string;
    total_capacity: number;
    same_day_service: boolean;
    disabled: boolean;
};

export type AvailableSlotsDTO = {
    date: string;
    slots: SlotDTO[];
};

export interface BookingDetailsDTO {
    status?: string;
    appointment_id?: string;
    location_details?: LocationDetailsDTO;
    vehicle_details?: VehicleDetailsDTO;
    pricing_details?: PricingDetailsDTO;
    slot_details?: SlotDetailsDTO;
    customer_details?: CustomerDetailsDTO;
    booking_details?: {
        appointment_fulfillment_type: BookingType;
    };
    coupon_details?: CouponDTO;
}

export interface CouponDTO {
    coupon_id: string;
    coupon_code: string;
    title: string;
    description: string;
    reward_value: number;
    reward_status: string;
    expired_on: string;
}

export interface LocationDetailsDTO {
    lat: number;
    lon: number;
    main_text: string;
    description: string;
    house_number: string;
    locality: string;
    pincode: number;
}

export interface VehicleDetailsDTO {
    registration_number: string;
    model_id: number;
    make: string;
    model: string;
}

export interface PricingDetailsDTO {
    base_amount: number;
    discount_value: any;
    discount_percent: any;
    discounted_amount: number;
    offer_price: string;
}

export interface SlotDetailsDTO {
    slot_id?: number;
    start_time: string;
    end_time: string;
    total_capacity: number;
    disabled: boolean;
    same_day_service: boolean;
}

export interface CustomerDetailsDTO {
    full_name: string;
    phone_number: string;
}

export interface IVehicleInfo {
    registration_number: string;
    acko_model_id: number;
    acko_make_id: string;
    make_name: string;
    model_name: string;
    registration_year: string;
    registration_month?: number;
    car_age?: number;
    acko_variant_id: number;
    variant_name: string;
    fuel_type: string;
    color: string;
}

export interface VehicleDetailsTransportData {
    registration_number?: string | null;
    make?: string | null;
    make_id?: number | string | null;
    model?: string | null;
    model_id?: number | string | null;
    fuel_type?: string | null;
    color?: string | null;
    registration_year?: number | string | null;
    registration_month?: number | string | null;
    car_age?: number | null;
    variant?: string | null;
    variant_id?: number | string | null;
}

export interface VehicleDetailsTransportResponse {
    text?: string | null;
    data?: VehicleDetailsTransportData | null;
    code?: string | null;
    error?: string | null;
}

export interface VehicleDetailsLookupResult {
    text: string | null;
    car_details: IVehicleInfo | null;
    error: string | null;
    photos?: { url?: string };
}

export interface SaveManualMmvInfoRequest {
    registration_number: string;
    variant_id: number;
    registration_year?: string;
    registration_month?: number;
}

export interface SaveManualMmvInfoTransportResponse {
    text?: string | null;
    data?: unknown;
}

export enum LocationModalType {
    LOCATION_ENABLE = 'location_enable',
    LOCATION_DISABLE = 'location_disable',
    LOCATION_DISABLE_NEW = 'location_disable_NEW',
}

export interface FormattedVehicleDetails {
    color: string | null;
    fuel_type: string | null;
    make: string | null;
    model: string | null;
    model_id: number | null;
    registration_number: string | null;
}

export interface CustomerDetails {
    email_id: string;
    full_name: string;
    phone_number: string;
}

export enum BookingType {
    SLOT_BOOKING = 'SLOT_BOOKING',
    PICK_AND_DROP = 'PICK_AND_DROP',
    SELF_DROP = 'SELF_DROP',
}
interface PricingDetail {
    amount: number;
}

export type ServicePricingDetails = {
    [key in BookingType]: PricingDetail;
};

export interface ICompany {
    id: number;
    name: string;
    url: string;
}

export interface IAckoGarage {
    garageId: string;
    garageAddress: string;
    garageBannerImage: {
        caption: string | null;
        imageUrl: string;
        imageThumbnail: string;
    };
    garagePhoneNumber: string;
    servicingBrands: Array<ICompany>;
    partSupplierBrands: Array<ICompany>;
    garageReviewRatings: IReviewRating;
    garageNumber: string;
    garageVideo: {
        caption: string | null;
        imageUrl: string;
    };
    garageTitle: string | null;
    garageDescription: string | null;
    garageKeywords: string | null;
    garageGallery: Array<{ imageUrl: string; id: number; imageName: string }>;
    garageTiming: { openTiming: string; closeTiming: string };
    garageDirectionUrl: string;
    garageOffers: Array<Offers> | [];
}
type Offers = {
    text: string;
    details: Array<string>;
    imgSrc: string;
};
export interface IReviewRating {
    id: number;
    ratings: number;
    total_review: number;
    reviews: Array<IReview>;
}

export interface IReview {
    id: number;
    reviewer_img_url: string;
    reviewer_name: string;
    review_text: string;
    review_date: string;
}

export interface CustomerDetails {
    full_name: string;
    phone_number: string;
    email_id: string;
}

export interface VehicleDetails {
    registration_number: string;
    make: string;
    model: string;
    model_id: number;
    fuel_type: string;
    color: string;
}

export interface SlotDetails {
    slot_id?: number;
    start_time: string;
    end_time: string;
    total_capacity: number;
    disabled: boolean;
    same_day_service: boolean;
    slot_type: string | null;
}

export interface BookingDetails {
    appointment_fulfillment_type: string;
    slot_id?: number;
    appointment_date: string;
    slot_details: SlotDetails;
    source: string;
    service_type: string;
}

export interface PaymentDetails {
    type: string;
    date: string;
    method: string;
    amount: number;
    is_final_bill_adjustable: boolean;
    payin_url: string;
    payment_status: string;
}

export interface IAppointmentDetails {
    central_user_id: string;
    partner_appointment_id: string;
    source: string;
    origin: string;
    service_type: string;
    appointment_id: string;
    customer_details: CustomerDetails;
    vehicle_details: VehicleDetails;
    booking_details: BookingDetails;
    pickup_details: Record<string, unknown>;
    payment_details: PaymentDetails;
    garage_id: string;
    status: string;
    reschedule_allowed: boolean;
    refund_possible: boolean;
}

export interface IAppointmentData {
    action: string;
    central_user_id: string;
    partner_appointment_id: string | null;
    source: string;
    origin: string;
    service_type: string;
    appointment_id: string;
    customer_details: {
        full_name: string;
        phone_number: string;
        email_id: string;
    };
    vehicle_details: {
        asset_id: string | null;
        registration_number: string;
        make: string;
        model: string;
        model_id: number;
        vin: string;
        fuel_type: string;
        color: string;
    };
    booking_details: {
        appointment_type: string;
        slot_id?: number;
        appointment_date: string;
        booking_date: string;
        complaints: string | null;
        slot_details: string | null;
        source: string | null;
        service_type: string | null;
    };
    pickup_details: {
        assigned_to: string;
        phone_number: string;
        address: {
            line: string;
            city: string;
            state: string;
            pincode: string;
            location_coords: {
                latitude: number;
                longitude: number;
            };
        };
    };
    payment_details: {
        type: string | null;
        date: string | null;
        method: string | null;
        amount: string | null;
        is_final_bill_adjustable: boolean | null;
        payin_url: string | null;
        ekey: string | null;
    };
    garage_id: string;
    status: string | null;
}
